{
  "language-selection-dialog": {
    "buttons": {
      "close": "Đóng"
    },
    "text": {
      "title": "Lựa chọn ngôn ngữ",
      "hint": "Chọn ngôn ngữ để hiển thị"
    }
  }
}
